import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpService } from "services/http.service";
import { QueryParams } from "services/models/odata/queryParams";
import { ProbationayDecisionTypeModel } from "services/models/probationary-period/probationary-period-decision-type.model";
import { ServiceBase } from "services/servicebase";

@Injectable()
export class ProbationaryPeriodDecisionTypeService extends ServiceBase<ProbationayDecisionTypeModel> {
  constructor(http: HttpService) {
    super("probationaryperiod/decisiontype", http, environment.apiUrl);
  }

  createEntity(input: any): ProbationayDecisionTypeModel {
    return ProbationayDecisionTypeModel.create(input);
  }

  getList(
    params: any,
    disableLoading: boolean = false
  ): Observable<ProbationayDecisionTypeModel[]> {
    const queryParams = `?${params.join("&")}`;
    return this.http
      .get(
        `${this.endpoint}/list${queryParams}`,
        null,
        null,
        null,
        disableLoading
      )
      .pipe(
        map((data: any) =>
          data.body.map((item) => ProbationayDecisionTypeModel.create(item))
        )
      );
  }
}
